import React, { forwardRef } from 'react';
import '../styles/FormControls.css';

const classNames = (...values) => values.filter(Boolean).join(' ');

const getVariantClass = (variant) => {
  if (variant === 'tomato') return 'df-form-control-tomato';
  if (variant === 'cinnabar') return 'df-form-control-cinnabar';
  return 'df-form-control-standard';
};

const getInputClasses = (type, variant, className) => {
  const variantClass = getVariantClass(variant);
  let controlClass = 'input input-bordered df-form-input';

  if (type === 'checkbox' || type === 'radio') {
    controlClass = 'checkbox checkbox-primary df-form-checkbox';
  } else if (type === 'range') {
    const rangeVariantClass =
      variant === 'tomato'
        ? 'range-secondary'
        : variant === 'cinnabar'
          ? 'range-cinnabar'
          : 'range-primary';
    controlClass = `range ${variant === 'tomato' ? 'range-secondary' : 'range-primary'} df-form-range`;
    controlClass = `range ${rangeVariantClass} df-form-range`;
  } else if (type === 'color') {
    controlClass = 'df-form-color';
  } else if (type === 'file') {
    controlClass = 'file-input file-input-bordered df-form-file';
  }

  return classNames(controlClass, variantClass, className);
};

export const Input = forwardRef(
  ({ type = 'text', variant = 'standard', className, ...props }, ref) => (
    <input
      {...props}
      ref={ref}
      type={type}
      aria-label={
        props['aria-label'] ||
        (!props['aria-labelledby'] &&
          type !== 'file' &&
          props.placeholder)
      }
      className={getInputClasses(type, variant, className)}
    />
  ),
);

Input.displayName = 'Input';

export const Select = forwardRef(
  ({ variant = 'standard', className, ...props }, ref) => (
    <select
      {...props}
      ref={ref}
      className={classNames(
        'select select-bordered df-form-select',
        getVariantClass(variant),
        className,
      )}
      aria-label={
        props['aria-label'] ||
        (!props['aria-labelledby'] && props.title ? props.title : undefined)
      }
    />
  ),
);

Select.displayName = 'Select';

export const TextArea = forwardRef(
  ({ variant = 'standard', className, ...props }, ref) => (
    <textarea
      {...props}
      ref={ref}
      className={classNames(
        'textarea textarea-bordered df-form-textarea',
        getVariantClass(variant),
        className,
      )}
      aria-label={
        props['aria-label'] ||
        (!props['aria-labelledby'] && props.placeholder
          ? props.placeholder
          : undefined)
      }
    />
  ),
);

TextArea.displayName = 'TextArea';
